
import utils from '@/utils';
import api from '@/api/login';
import { defineComponent } from 'vue';
import { IElForm } from '@/types/element';
import { auth } from '@/store';

interface IForm {
  type: string;
  account: string;
  password: string;
  mobile: string;
  code: string;
  captchaValue: string;
}

interface IState {
  status: number;
  redirect: string;
  pageAlert: {
    type: string;
    title: string;
  };
  captchaToken: string;
  captchaUrl: string;
  isSmsEnabled: boolean;
  countdown: number;
  form: IForm;
  validateMobile: (rule: { message: string }, value: string, callback: (error?: Error) => void) => void;
}

export default defineComponent({
  data() {
    return {
      status: utils.toInt(this.$route.query.status),
      redirect: this.$route.query.redirect,
      pageAlert: {},
      captchaToken: '',
      captchaUrl: '',
      isSmsEnabled: false,
      countdown: 0,
      form: {
        type: 'account',
        account: '',
        password: '',
        mobile: '',
        code: '',
        captchaValue: '',
      },
      validateMobile: utils.validateMobile,
    } as IState;
  },
  methods: {
    apiGet() {
      if (this.status === 401) {
        this.pageAlert = {
          type: 'error',
          title: '您的账号登录已过期或失效，请重新登录',
        };
      }

      api.get((res) => {
        this.isSmsEnabled = res.isSmsEnabled;
        this.apiCaptcha();
      });
    },

    apiCaptcha() {
      api.captchaNew((res) => {
        this.captchaToken = res.value;
        this.captchaUrl = api.getCaptchaUrl(this.captchaToken);
        this.btnTypeClick();
      });
    },

    apiCaptchaCheck() {
      api.captchaCheck(
        {
          token: this.captchaToken,
          value: this.form.captchaValue,
        },
        (res) => {
          if (!res.value) return;
          this.apiSubmit();
        },
        () => {
          api.captchaNew((res) => {
            this.captchaToken = res.value;
            this.captchaUrl = api.getCaptchaUrl(this.captchaToken);
            (this.$refs.captcha as HTMLInputElement).focus();
          });
        },
      );
    },

    apiSendSms() {
      api.sendSms(
        {
          mobile: this.form.mobile,
        },
        (res) => {
          if (!res.value) return;
          utils.notifySuccess('验证码发送成功，10分钟内有效');
          this.countdown = 60;
          const interval = setInterval(() => {
            this.countdown -= 1;
            if (this.countdown <= 0) {
              clearInterval(interval);
            }
          }, 1000);
        },
      );
    },

    apiSubmit() {
      api.submit(
        {
          isSmsLogin: this.form.type === 'mobile',
          account: this.form.account,
          password: this.form.password,
          mobile: this.form.mobile,
          code: this.form.code,
        },
        (res) => {
          auth.login(res.token, res.user);
          if (utils.isAbsoluteUrl(this.redirect)) {
            window.location.href = this.redirect;
          } else if (this.redirect) {
            utils.pageOpen(this.redirect);
          } else {
            this.redirectIndex();
          }
        },
        () => {
          this.apiCaptcha();
        },
      );
    },

    redirectIndex() {
      utils.pageOpen('/');
    },

    redirectLostPassword() {
      utils.pageOpen('lostPassword');
    },

    btnTypeClick() {
      if (this.$refs.formAccount) {
        (this.$refs.formAccount as IElForm).clearValidate();
      }
      if (this.$refs.formMobile) {
        (this.$refs.formMobile as IElForm).clearValidate();
      }
      if (this.form.type === 'account') {
        setTimeout(() => {
          if (this.$refs.account) {
            (this.$refs.account as HTMLInputElement).focus();
          }
        }, 100);
      } else if (this.form.type === 'mobile') {
        setTimeout(() => {
          if (this.$refs.mobile) {
            (this.$refs.mobile as HTMLInputElement).focus();
          }
        }, 100);
      }
    },

    btnCaptchaClick() {
      this.apiCaptcha();
    },

    isMobile(value: string) {
      return /^1[3-9][0-9]\d{8}$/.test(value);
    },

    btnSendSmsClick() {
      if (this.countdown > 0) return;
      if (!this.form.mobile) {
        utils.notifyError('手机号码不能为空');
        return;
      }
      if (!this.isMobile(this.form.mobile)) {
        utils.notifyError('请输入有效的手机号码');
        return;
      }

      this.apiSendSms();
    },

    btnSubmitClick() {
      if (this.form.type === 'account') {
        (this.$refs.formAccount as IElForm).validate((valid) => {
          if (valid) {
            this.apiCaptchaCheck();
          }
        });
      } else {
        (this.$refs.formMobile as IElForm).validate((valid) => {
          if (valid) {
            this.apiSubmit();
          }
        });
      }
    },

    btnRegisterClick() {
      if (this.redirect) {
        utils.pageOpen('register', { redirect: this.redirect });
      } else {
        utils.pageOpen('register');
      }
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'production') {
      const redirect = this.redirect || '/home/';
      window.location.href = `https://sscms.com/auth.html?redirect=${redirect}`;
    } else {
      this.apiGet();
    }
  },
});
